package horcrux.frontend.common.views.auth

import arrow.core.toOption
import horcrux.common.api.dtos.types.EmailAddress
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.get
import horcrux.frontend.common.isInvalid
import horcrux.frontend.common.set
import horcrux.frontend.common.value
import mui.material.AlertColor
import mui.material.Button
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogContentText
import mui.material.FormControlMargin
import mui.material.TextField
import react.FC
import react.Props
import react.ReactNode
import react.dom.onChange
import react.router.useNavigate
import react.useState
import web.html.InputType

external interface ForgotPasswordDialogProps : Props {
    var showDialogState: BooleanState
    var globalAppState: GlobalAppState
}

val INVALID_EMAIL_HELPER_TEXT = ReactNode("Please input a valid email")

val ForgotPasswordDialog = FC<ForgotPasswordDialogProps> { props ->
    val emailAddressMaybeState = useState<EmailAddress?>(null)
    val isInvalidEmail = emailAddressMaybeState.isInvalid()
    val navigate = useNavigate()

    fun closeDialog() {
        props.showDialogState.set(false)
        emailAddressMaybeState.set(null)
    }

    Dialog {
        this.id = "reset-password-dialog"
        this.title = "Reset Password"
        this.open = props.showDialogState.get()
        DialogContent {
            DialogContentText {
                +"Enter your email. We will send you a link to reset your password."
            }
            TextField {
                this.margin = FormControlMargin.normal
                this.required = true
                this.fullWidth = true
                this.id = "enter-email-password-reset"
                this.label = ReactNode("Email Address")
                this.type = InputType.email
                this.name = "email"
                this.autoComplete = "email"
                this.autoFocus = true
                this.error = isInvalidEmail
                this.helperText = if (isInvalidEmail) INVALID_EMAIL_HELPER_TEXT else null
                this.onChange = { event ->
                    emailAddressMaybeState.set(EmailAddress(event.value()))
                }
            }
        }
        DialogActions {
            Button {
                +"Cancel"
                this.onClick = { closeDialog() }
            }
            Button {
                +"Reset"
                this.onClick = {
                    emailAddressMaybeState
                        .get()
                        .toOption()
                        .filter { !isInvalidEmail }
                        .map { email ->
                            props.globalAppState.submitAuthenticationClientAPIRequest { authenticationClient ->
                                authenticationClient
                                    .sendPasswordResetEmail(email)
                                    .map {
                                        props.globalAppState.updateBanner(
                                            AlertColor.info,
                                            "We sent a reset link to your email. Please check your inbox."
                                        )
                                        closeDialog()
                                    }
                                    .bind()
                            }
                        }
                }
            }
        }
    }
}
